"use client";
import ArrowDownIcon from "@heroicons/react/16/solid/ArrowDownIcon";
import XCircleIcon from "@heroicons/react/24/outline/XCircleIcon";
import {useEffect, useState} from "react";
import Image from "next/legacy/image";
import {useLayoutContext} from "../../context";
import {useFrontendConfiguratorContext} from "../../ProductConfigurator/context";
import {usePhrase} from "../../../i18n";
import {sendGTMEvent} from "@next/third-parties/google";
import {pixelEvent} from "../../FBPixel/pixel";
import {nl2br, parseText} from "../../../../provider/magento/normalizers";
import HTMLString from "react-html-string";

const roundPrice = (price) => {
    //console.log(Number.EPSILON);
    return Math.round(parseFloat(price) * 100) / 100;

}

const normalizeSku = (sku) => {
    return sku.replace(/[^a-zA-Z0-9]/g, '_');
}

const DropDown = ({
                      id,
                      name,
                      value,
                      option,
                      currency,
                      className,
                      placeholder,
                      itemId = null,
                      showLabel = true,
                      priceUnit = null,
                      onChange,
                      _t
                  }) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [availableValues, setAvailableValues] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [visible, setVisible] = useState(option.is_visible && option.is_visible == '1' ? true : false);
    const {overflow, setPageOverflow} = useLayoutContext();
    const {setup, currentConfiguration, setCurrentConfigurationOption} = useFrontendConfiguratorContext();

    const [isLoaded, setIsLoaded] = useState(false);
    const [suggestedActions, setSuggestedActions] = useState([]);

    const t = usePhrase(_t);


    useEffect(() => {
        if (modalOpen) {
            if (!isLoaded) {
                setIsLoaded(true);
            }
            //  if(!overflow) setPageOverflow(true);
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'hidden';
            }
        } else {
            //   if(overflow) setPageOverflow(false);
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'auto';
            }
        }
        return () => {
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'auto';
            }
        }
    }, [modalOpen]);


    useEffect(() => {
        //if (modalOpen) {
        checkAvailableValues();
        //}
    }, [modalOpen, currentConfiguration?.actions.filter(a => a.option === option.option_id).map(a => a.action_id).join(',')]);


    useEffect(() => {


        // @TODO rewrite this for rule priority
        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'exclude').length > 0) {
            setDisabled(true);
        }
        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'include').length > 0) {
            setDisabled(false);
        }


        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.optionValue && a.optionValue.length > 0 && a.action === 'suggest').length > 0) {
            let tmpSuggestedActions = [...suggestedActions];
            for (let action of currentConfiguration.actions.filter(a => !suggestedActions.includes(a.action_id) && a.option === option.option_id && a.optionValue.length > 0 && a.action === 'suggest')) {
                let suggestedValue = availableValues.find(v => /*!v?.exclude && */v.option_type_id == action.optionValue);
                if (onChange) onChange({name: option.option_id, value: suggestedValue});
                tmpSuggestedActions.push(action.action_id);
            }
            setSuggestedActions(tmpSuggestedActions);
        }

        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'hide').length > 0) {
            setVisible(false);
        } else if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'show').length > 0) {
            setVisible(true);
        } else {
            setVisible(!!(option.is_visible && option.is_visible == '1'));
        }


    }, [currentConfiguration?.actions.filter(a => a.option === option.option_id).map(a => a.action_id).join(',')]);

    const handleChange = (e) => {
        if (onChange) onChange({name: e.name, value: e.value});
        sendGTMEvent({
            event: 'item_configuration',
            product: setup?.product?.sku || '',
            option: option?.sku || '',
            value: e.value?.sku || '',
        });
        pixelEvent('CustomizeProduct', {
            content_ids: [setup?.product?.sku || ''],
            content_type: 'product',
            value: e.value?.sku || ''
        });
        setModalOpen(false);
    }

    const calcOptionFinalPrice = (curItem, withCurrency = false) => {

        //let curSubj = curItem;

        //console.log(curItem);

        if (curItem && curItem.price && curItem.price == 0) {
            return;
        }

        //console.log(`---- ${option.title} ----`);
        //console.log(curItem);

        const baseOptionPrice = curItem.price;
        const priceType = curItem.price_type;


        let finalPrice = 0;
        let valuePrice = 0;
        let basePrice = setup.product.price;


        if (priceType === 'percent') {


            if (!curItem.price_target || curItem.price_target === 'base') {


                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).filter(opt => parseFloat(opt.price_order) < parseFloat(option.price_order)).map(opt => {


                    let curSubj = opt;

                    if (opt.value && opt.value.option_type_id)
                        curSubj = opt.value;


                    if ((!curSubj.price || curSubj.price == "0") || (curSubj.price_target && curSubj.price_target !== 'base')) return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : (parseFloat(basePrice) * (parseFloat(curSubj.price)) / 100));

                    basePrice += addPrice;

                });

                valuePrice = +parseFloat((parseFloat(curItem.price) * parseFloat(basePrice)) / 100).toFixed(2);


            } else {
                basePrice = currentConfiguration.price;

                if (setup.priceFormula && setup.priceFormula.length > 0)
                    basePrice = currentConfiguration.priceFormulaPrice;


                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).filter(opt => parseFloat(opt.price_order) < parseFloat(option.price_order)).map(opt => {


                    let curSubj = opt;

                    if (opt.value && opt.value.option_type_id)
                        curSubj = opt.value;

                    if ((!curSubj.price || curSubj.price == "0") || (curSubj.price_target && curSubj.price_target !== 'final')) return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : parseFloat(basePrice) * (parseFloat(curSubj.price) / 100));

                    basePrice += addPrice;

                });

                valuePrice = +parseFloat((parseFloat(curItem.price) * parseFloat(basePrice)) / 100).toFixed(2);


            }


            finalPrice = +parseFloat(valuePrice).toFixed(2);


        } else {

            if (!curItem.price_target || curItem.price_target === 'base') {

                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).filter(opt => parseFloat(opt.price_order) < parseFloat(option.price_order)).map(opt => {

                    let curSubj = opt;

                    if (opt.value && opt.value.option_type_id)
                        curSubj = opt.value;

                    if ((!curSubj.price || curSubj.price == "0") || (curSubj.price_target && curSubj.price_target !== 'base')) return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : (parseFloat(basePrice) * (parseFloat(curSubj.price)) / 100));


                    basePrice += addPrice;

                });


            } else {
                basePrice = currentConfiguration.price;

                if (setup.priceFormula && setup.priceFormula.length > 0)
                    basePrice = currentConfiguration.priceFormulaPrice;


                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).filter(opt => parseFloat(opt.price_order) < parseFloat(option.price_order)).map(opt => {

                    let curSubj = opt;

                    if (opt.value && opt.value.option_type_id)
                        curSubj = opt.value;

                    if ((!curSubj.price || curSubj.price == "0") || (curSubj.price_target && curSubj.price_target !== 'final')) return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : parseFloat(basePrice) * (parseFloat(curSubj.price) / 100));

                    basePrice += addPrice;

                });


            }

            finalPrice = +parseFloat(baseOptionPrice).toFixed(2);
        }


        if (finalPrice === 0) return null;

        // apply promo
        if (setup.product.promo && setup.product.promo > 0)
            finalPrice = parseFloat(finalPrice) - parseFloat((finalPrice * (setup.product.promo / 100)));

        // apply tax
        if (setup.product.tax && setup.product.tax > 0)
            finalPrice = parseFloat(finalPrice) + parseFloat((finalPrice * (setup.product.tax / 100)));

        basePrice = roundPrice(basePrice);

        if (withCurrency)
            finalPrice = (parseFloat(finalPrice) > 0 ? '+' : '') + parseFloat(finalPrice).toFixed(2) + ' ' + currency + ((curItem.price_target && curItem.price_target === 'final') ? '' : ( priceUnit ? ` / ${priceUnit}` : ''));

        return finalPrice;

    }


    const checkAvailableValues = () => {

        let tmpAvailableValues = [...option.values.map(v => ({...v, exclude: false}))];

        currentConfiguration.actions.filter(a => a.action === 'exclude').map((action, actionIndex) => {
            if (action.option === option.option_id) {
                tmpAvailableValues = (!action.optionValue) ? [] : tmpAvailableValues.map(opt => opt.option_type_id == action.optionValue ? {
                    ...opt,
                    exclude: true
                } : opt);
            }
        });

        currentConfiguration.actions.filter(a => a.action === 'include').map((action, actionIndex) => {
            if (action.option === option.option_id) {
                tmpAvailableValues = (!action.optionValue) ? [] : tmpAvailableValues.map(opt => opt.option_type_id == action.optionValue ? {
                    ...opt,
                    exclude: false
                } : opt);
            }
        });
        //console.log(tmpAvailableValues);

        if (tmpAvailableValues.filter(opt => !opt?.exclude).sort(opt => opt.option_type_id).map(opt => opt.option_type_id).join(',') !== availableValues.filter(opt => !opt?.exclude).sort(opt => opt.option_type_id).map(opt => opt.option_type_id).join(',')) {
            setAvailableValues(tmpAvailableValues);
        }

        //if (value) {
        const selectedValue = value && value.option_type_id ? tmpAvailableValues.filter(opt => !opt?.exclude && opt.option_type_id == value?.option_type_id) : [];

        //console.log(selectedValue);
        if (selectedValue.length === 0 && !itemId) {
            // @TODO HARDCODING COL AND des_subcliente OPTION
            let newValue = (option.sku !== 'COL' && option.sku !== 'des_subcliente') ? (tmpAvailableValues.filter(opt => !opt?.exclude)[0] || null) : null;
            if (onChange) onChange({name: option.option_id, value: newValue});
        }
        //}

    }

    const renderValue = (item) => {
        {
            const isSelected = value && value.option_type_id == item.option_type_id;
            const isDisabled = !availableValues.filter(opt => !opt?.exclude).map(opt => opt.option_type_id).includes(item.option_type_id);
            const finalPrice = calcOptionFinalPrice(item, true);

            return <div key={['option', option.option_id, 'value', item.option_type_id].join('_')}
                        id={['option', normalizeSku(option.sku), 'value', normalizeSku(item.sku)].join('_')}
                        className={`${isDisabled ? 'disabled' : ''} relative min-h-[3.5rem] flex flex-shrink-0 justify-start items-center 
                        mx-3  rounded border border-[#ddd] hover:border-[#aaa] overflow-hidden ${isSelected ? 'border-2 !border-[#e7bb43] shadow-[0_0px_0px_3px_#fff0c2] ' : ''} ${!isDisabled ? 'cursor-pointer' : 'cursor-not-allowed'} hover:bg-gray-50`}
                        onClick={() => !isDisabled && handleChange({name: option.option_id, value: item})}>


                {item.image && <div className={'relative flex-shrink-0 w-[90px] h-[90px] m-2'}>

                    <Image src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product/option/' + item.image}
                           alt={item.title}
                           layout={'responsive'}
                           placeholder={'blur'}
                           blurDataURL={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product/option/' + item.thumb}
                           width={90}
                           height={90}
                           sizes={'90px'}
                           className="object-cover object-center rounded "/>

                </div>}

                <div
                    className={`flex flex-col justify-between h-full grow ${item.image ? 'ml-2' : 'px-2'} py-1  mr-2 `}>
                    <div className={`h-full flex flex-col ${item.description ? 'justify-start' : 'justify-center'}`}>
                        <h6 className={`text-md font-light capitalize ${isSelected ? '!font-bold' : ''}`}>
                            {item.title}
                            {/* {isSelected && <CheckCircleIcon className={`h-6 w-6 text-green-800 ml-1`}/>}*/}
                        </h6>

                        {item.description &&
                            <div className={`dropdown-item-description text-sm lg:text-xs text-gray-600 text-justify`}>{("string" == typeof parseText(item.description)) && <HTMLString html={parseText(item.description)} />}</div>}
                    </div>
                    <div>
                        <span className={'text-sm font-normal'}>{finalPrice}</span>
                        {item.variables && item.variables.filter(variable => variable.code === 'MIN_FAT').map(variable =>
                            <p key={`item_variable_${item.option_type_id}_${variable.code}`}
                               className={`text-xs mt-1`}>{t('Minimum billable')}: {variable.value} {priceUnit ? priceUnit : ''}</p>)}
                    </div>
                </div>
                {isDisabled &&
                    <div className={'absolute inset-0 top-0 left-0 w-full h-full bg-gray-100 opacity-50 z-10'}/>}
            </div>
        }


    }


    const renderValues = () => {

        if (availableValues.length === 0) return null;

        if (option.categories && option.categories.length > 0) {


            return option.categories.sort((a, b) => a.sort_order - b.sort_order).map((category, categoryIndex) => {

                if (option.values.filter(v => v.category_id === category.option_type_category_id).length === 0) return null;

                return <div key={['option', option.option_id, 'category', category.option_type_category_id].join('_')}>
                    <h6 className={`bg-[#fafafa] border-b px-4 py-1 text-md lg:text-lg font-bold text-gray-800 mb-2`}>{category.title}</h6>
                    <div className={`space-y-2 my-2`}>
                        {option.values &&
                            option.values.filter(v => v.category_id === category.option_type_category_id).length > 0 &&
                            option.values.filter(v => v.category_id === category.option_type_category_id).sort((a, b) => a.sort_order - b.sort_order).map((item, index) => renderValue(item))}
                    </div>
                </div>
            })
        } else {
            return <div
                className={`space-y-2 my-2`}>{option.values.sort((a, b) => a.sort_order - b.sort_order).map((item, index) => renderValue(item))}</div>;
        }

    }


    return <div className={` ${visible ? '' : 'hidden'}`}>
        {showLabel &&
            <h3 className={'font-bold mb-0.5 capitalize text-lg lg:text-base'}>{option.title}{option.is_require == "1" && "*"}:</h3>}
        <div>
            <button
                id={id}
                name={[`option_`, `dropdown`, name].join('_')}
                aria-label={option.title}
                className={[`${option.is_require == "1" && "required"} w-full py-1.5 px-2 flex justify-between items-center rounded border border-[#bdbdbd] h-[45px]`, className].join(' ')}
                onClick={() => setModalOpen(true)}>
                {value ? <div className={`flex w-full justify-between items-center relative`}>

                    <div className={'flex items-center '}>
                        {value.thumb && <div className={'h-8 w-8 mr-2 relative'}>
                            <Image
                                src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product/option/' + value.thumb}
                                alt={value.title}
                                layout={'responsive'}
                                height={40}
                                width={40}
                                sizes={'40px'}
                                className="w-full object-cover object-center !border !border-solid !border-[#ABABAB] rounded-[4px]"/>
                        </div>}
                        <span className={'text-md lg:text-base overflow-x-hidden capitalize'}>{value.title}</span>
                    </div>
                    <div className={'absolute right-0 bg-white top-[40%] lg:top-[50%] -translate-y-1/2 '}><span
                        className={`text-xs lg:text-sm pl-3 lg:pl-0  mr-2`}>{calcOptionFinalPrice(value, true)}</span>
                    </div>
                </div> : <span
                    className={'text-gray-600 text-md lg:text-base overflow-x-hidden py-0.5'}>{placeholder}</span>}
                <span><ArrowDownIcon className={'w-5 h-5 text-[#000]'}/></span>
            </button>

            <div className={``}>

                {modalOpen && <div
                    className={`fixed top-0 left-0 w-full h-full z-[70] bg-black/75 transition-opacity cursor-pointer ${!modalOpen && 'bg-opa'}`}
                    onClick={() => setModalOpen(false)}></div>}


                <div
                    className={`fixed bottom-0 w-full h-5/6 lg:bottom-auto lg:top-0 right-0 lg:w-[450px] bg-white z-[70] lg:h-full flex flex-col ease-in-out duration-300 translate ${modalOpen ? 'translate-y-0  lg:translate-x-0' : 'translate-y-full lg:translate-y-0 lg:translate-x-full'}`}>
                    {isLoaded && <>
                        <div className={`flex justify-between items-center py-4 px-4`}>
                            <h3 className={`text-xl font-bold`}>{option.title}</h3>
                            <span onClick={() => setModalOpen(false)}><XCircleIcon className={`h-6 w-6`}/></span>
                        </div>

                        <div className={` grow flex flex-col overflow-y-scroll h-auto bg-[#fdfdfd] border-t`}>
                            {renderValues()}
                        </div>

                    </>}


                </div>

            </div>
        </div>
    </div>;

}

export default DropDown;